import React, { Fragment } from 'react';
import axios from 'axios';
import download from 'downloadjs';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Form, Segment } from 'semantic-ui-react';
import { fetchLanguages, fetchDocumentTypes, fetchCertificateReasons, fetchDocumentTemplates, fetchDocumentStatuses } from '../Lookups/util';
import { extractFileNameFromHeaders } from '../DegreeDocumentPrint/util/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const DOC_TEXTS = {
    STATUS_CERTIFICATE: 'Statusna potvrda',
    TRANSCRIPT_OF_RECORDS: 'Prepis ocjena',
    TRANSCRIPT_OF_RECORDS_PER_YEAR: 'Prepis ocjena (po godinama studija)',
    WITHDRAWAL: 'Ispisnica',
    COMPLETED_STUDY_CYCLE_CERTIFICATE: 'Uvjerenje o završenom ciklusu studija',
    NON_CYCLE_CERTIFICATE: 'Certifikat - neciklični studij',
    CERTIFICATE_SUPPLEMENT: 'Dodatak Certifikatu - neciklični studij',
};

export default class GetCertificate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            documentLanguages: [],
            language: '',
            documentType: '',
            certificateReason: '',
            docLanguages: [],
            loader: true,
            documentTypeError: false,
            certificateReasonIdError: false,
            loading: false,

            languages: [],
            documentTypes: [],
            certificateReasons: [],
            documentTemplates: [],
            documentStatuses: []
        };
        this.sendDocumentRequest = this.sendDocumentRequest.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getSelectedLanguageCode = this.getSelectedLanguageCode.bind(this);
        this.showDocumentDownloadError = this.showDocumentDownloadError.bind(this);
        this.handleDocumentDownloadResponse = this.handleDocumentDownloadResponse.bind(this);
        this.getDocTemplateIdFromDocTypeId = this.getDocTemplateIdFromDocTypeId.bind(this);
        this.getStatusCertificateId = this.getStatusCertificateId.bind(this);
        this.getWithdrawalForm = this.getWithdrawalForm.bind(this);
        this.graduationCerificate = this.graduationCerificate.bind(this);
        this.nonCycleCerificate = this.nonCycleCerificate.bind(this);
        this.certificateSupplement = this.certificateSupplement.bind(this);
        this.nonCycleTranscript = this.nonCycleTranscript.bind(this);
        this.processRequest = this.processRequest.bind(this);
        this.processed = this.processed.bind(this);
    }

    componentDidMount() {
        this.setState({
            language: 1,
            documentLanguages: [
                {
                    text: window.$locale === 'en' ? 'B/H/S language' : 'B/H/S jezik',
                    key: 1,
                    value: 1
                },
                {
                    text: window.$locale === 'en' ? 'English language' : 'Engleski jezik',
                    key: 2,
                    value: 2
                },
            ]
        });

        axios.all([fetchLanguages(), fetchDocumentTypes(), fetchCertificateReasons(), fetchDocumentTemplates(), fetchDocumentStatuses()])
            .then(axios.spread((languagesRes, documentTypeRes, certificateReasonRes, documentTemplatesRes, documentStatusRes) => {
                const languages = languagesRes.data;
                const documentTypes = documentTypeRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const certificateReasons = certificateReasonRes.data.map(el => ({
                    ...el,
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale)
                        ? el.translations.find(e => e.language === window.$locale).name : el.name : el.name)
                }));
                const documentStatuses = documentStatusRes.data;
                const documentTemplates = documentTemplatesRes.data;
                this.setState({
                    languages,
                    documentTypes,
                    certificateReasons,
                    documentTemplates,
                    documentStatuses
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch languages, document types or templates');
            });
    }

    getStatusCertificateId() {
        const { documentTypes } = this.state;
        const selected = documentTypes.find(el => el.text === 'Statusna potvrda');
        if (selected && selected.id) return selected.id;
        return '';
    }

    getGenericCertificateReasonId() {
        const { certificateReasons } = this.state;
        const selected = certificateReasons.find(el => el.text === 'Regulisanje statusnih pitanja');
        if (selected && selected.id) return selected.id;
        return '';
    }

    getDocTemplateIdFromDocTypeId(docType) {
        const { documentTemplates } = this.state;
        const selected = documentTemplates.find(el => el.documentType.id === docType);
        if (selected && selected.id) return selected.id;
        return '';
    }

    handleInputChange(event, { name, value }) {
        if (name === 'documentType') {
            if (value !== this.getStatusCertificateId()) {
                this.setState({ certificateReason: '' });
            }
        }
        this.setState({
            [name]: value
        });
    }

    getSelectedLanguageCode(language = this.state.language) {
        return language === 1 ? 'bs' : 'en';
    }

    showDocumentDownloadError(blob) {
        if (!blob) {
            toast('Došlo je do greške! Zahtjev nije obrađen.');
            return;
        }

        const reader = new FileReader();

        reader.onload = () => {
            try {
                const parsedResponse = JSON.parse(reader.result);

                if (parsedResponse && parsedResponse.message) {
                    toast(parsedResponse.message);
                    return;
                }

                if (parsedResponse && parsedResponse.failingDegrees) {
                    toast('Došlo je do greške! Dokument nije moguće preuzeti.');
                    return;
                }
            } catch (e) {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            }
        };

        reader.onerror = () => {
            toast('Došlo je do greške! Zahtjev nije obrađen.');
        };

        reader.readAsText(blob);
    }

    handleDocumentDownloadResponse(res, emptyMessage = 'Došlo je do greške! Zahtjev nije obrađen zbog nedostatka podataka.') {
        if (!res.data || res.data.size === 0) {
            toast(emptyMessage);
            return false;
        }

        const contentType = res.headers['content-type'] || '';

        if (contentType.includes('application/json') || contentType.includes('text/plain')) {
            this.showDocumentDownloadError(res.data);
            return false;
        }

        const fileName = extractFileNameFromHeaders(res.headers);
        download(res.data, fileName);
        return true;
    }

    sendDocumentRequest(documentTypeId, certificateReasonId) {
        if (this.props.externalStudent) {
            certificateReasonId = this.getGenericCertificateReasonId(); // eslint-disable-line no-param-reassign
        }
        if (!documentTypeId) {
            this.setState({
                documentTypeError: true
            });

            toast(<FormattedMessage id="studentDocuments.errInputToast" />);
            return;
        } else if (this.state.documentType === this.getStatusCertificateId() && !certificateReasonId) {
            this.setState({
                certificateReasonIdError: true, documentTypeError: false
            });
            toast(<FormattedMessage id="studentDocuments.errInputToast" />);
            return;
        }
        this.setState({ loading: true });
        let docRequest = {};

        if (documentTypeId) docRequest = { ...docRequest, documentTypeId };
        if (certificateReasonId) docRequest = { ...docRequest, certificateReasonId };

        if (this.props.externalStudent) {
            docRequest = {
                ...docRequest,
                language: this.getSelectedLanguageCode(),
                externalStudentId: this.props.student.id
            };
        } else {
            docRequest = {
                ...docRequest,
                language: this.getSelectedLanguageCode(),
                studentStudyProgramId: this.props.studentStudyProgramId
            };
        }

        if (this.props.externalStudent) {
            axios.post('student-documents/create-request-for-external-student', { ...docRequest })
                .then(res => {
                    console.log('res.data.language.id ', res.data.language.id);
                    this.processRequestForExternalStudent(
                        this.props.student.id,
                        res.data.documentType.id,
                        res.data.id,
                        res.data.language.id === 2 ? 'en' : 'bs'
                    );
                })
                .catch(err => {
                    if (err.response.data === 'This document is already in queue!') {
                        toast('Zahtjev za ovaj dokument već postoji i nije obrađen.');
                    } else { toast('Došlo je do greške! Zahtjev nije uspješno podnesen.'); }
                    this.setState({ loading: false });
                });
        } else {
            axios.post('student-documents/create-request-for-student', { ...docRequest })
                .then(res => {
                    console.log('res.data.language.id ', res.data.language.id);
                    this.processRequest(
                        this.props.studentStudyProgramId,
                        res.data.documentType.id,
                        res.data.id,
                        res.data.language.id === 2 ? 'en' : 'bs'
                    );
                })
                .catch(err => {
                    if (err.response.data === 'This document is already in queue!') {
                        toast('Zahtjev za ovaj dokument već postoji i nije obrađen.');
                    } else { toast('Došlo je do greške! Zahtjev nije uspješno podnesen.'); }
                    this.setState({ loading: false });
                });
        }
    }

    processed(documentRequestId) {
        axios.put(`student-documents/process-request/${documentRequestId}`)
            .then(res => {
                this.setState({ loading: false });
            })
            .catch(err => {
                this.setState({ loading: false });
                console.log('Failed to process request.');
            });
    }

    processRequest(studentStudyProgramId, documentTypeId, documentRequestId, language) {
        let issueDate = moment(new Date()).format();
        let obj = {
            studentStudyProgramId,
            documentTypeId,
            documentRequestId,
            issueDate,
            language,
            withLogo: false,
            externalStudentId: null
        };

        axios({
            method: 'post',
            url: '/documents/requested',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (!this.handleDocumentDownloadResponse(res)) {
                    this.setState({ loading: false });
                    return;
                }
                this.processed(documentRequestId);
            })
            .catch(err => {
                this.setState({ loading: false });
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            });
    }

    processRequestForExternalStudent(externalStudentId, documentTypeId, documentRequestId, language) {
        let issueDate = moment(new Date()).format();
        let obj = {
            studentStudyProgramId: null,
            externalStudentId,
            documentTypeId,
            documentRequestId,
            issueDate,
            language,
            withLogo: false
        };

        axios({
            method: 'post',
            url: '/documents/requested',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (!this.handleDocumentDownloadResponse(res)) {
                    this.setState({ loading: false });
                    return;
                }
                this.processed(documentRequestId);
            })
            .catch(err => {
                this.setState({ loading: false });
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            });
    }

    getWithdrawalForm(studentStudyProgramId) {
        this.setState({ loading: true });
        let issueDate = moment(new Date()).format();
        let obj = {
            studentStudyProgramId, issueDate, language: window.$locale, withLogo: false
        };
        axios({
            method: 'post',
            url: '/documents/withdrawal-form',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                this.handleDocumentDownloadResponse(res);
                this.setState({ loading: false });
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
                this.setState({ loading: false });
            });
    }

    graduationCerificate(ids, studyCycle) {
        this.setState({ loading: true });
        let issueDate = moment(new Date()).format();
        const params = {
            language: this.getSelectedLanguageCode(), ids, issueDate, studyCycle, withLogo: false
        };
        axios({
            method: 'post',
            url: '/graduation-documents/print-completed-study-cycle-certificate',
            responseType: 'blob',
            data: { ...params }
        })
            .then(res => {
                this.handleDocumentDownloadResponse(res);
                this.setState({ loading: false });
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
                this.setState({ loading: false });
            });
    }

    mobilityCerificate(id, language) {
        this.setState({ loading: true });
        let issueDate = moment(new Date()).format();
        const params = {
            language: this.getSelectedLanguageCode(language),
            ids: [id],
            issueDate,
            withLogo: true
        };
        axios({
            method: 'post',
            url: '/graduation-documents/print-non-cycle-certificate/external',
            responseType: 'blob',
            data: { ...params }
        })
            .then(res => {
                this.handleDocumentDownloadResponse(res);
                this.setState({ loading: false });
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
                this.setState({ loading: false });
            });
    }

    nonCycleCerificate(id, language) {
        this.setState({ loading: true });
        let issueDate = moment(new Date()).format();
        const params = {
            language: this.getSelectedLanguageCode(language),
            ids: [id],
            issueDate,
            withLogo: true
        };

        axios({
            method: 'post',
            url: '/graduation-documents/print-non-cycle-certificate/non-cycle',
            responseType: 'blob',
            data: { ...params }
        })
            .then(res => {
                this.handleDocumentDownloadResponse(res);
                this.setState({ loading: false });
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
                this.setState({ loading: false });
            });
    }

    certificateSupplement(id, language, routeType) {
        this.setState({ loading: true });
        let issueDate = moment(new Date()).format();
        const params = {
            language: this.getSelectedLanguageCode(language),
            ids: [id],
            issueDate,
            withLogo: true
        };

        const supplementRoute = routeType === 'external' ? 'external' : 'non-cycle';

        axios({
            method: 'post',
            url: `/graduation-documents/print-non-cycle-supplement/${supplementRoute}`,
            responseType: 'blob',
            data: { ...params }
        })
            .then(res => {
                this.handleDocumentDownloadResponse(res);
                this.setState({ loading: false });
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
                this.setState({ loading: false });
            });
    }

    nonCycleTranscript(id, language, routeType) {
        this.setState({ loading: true });
        let issueDate = moment(new Date()).format();
        const params = {
            language: this.getSelectedLanguageCode(language),
            ids: [id],
            issueDate,
            withLogo: true
        };

        const transcriptRoute = routeType === 'external' ? 'external' : 'non-cycle';

        axios({
            method: 'post',
            url: `/graduation-documents/print-non-cycle-transcript/${transcriptRoute}`,
            responseType: 'blob',
            data: { ...params }
        })
            .then(res => {
                this.handleDocumentDownloadResponse(res);
                this.setState({ loading: false });
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
                this.setState({ loading: false });
            });
    }

    getAllowedDocumentTexts({
        externalStudent,
        showMobilityCertificate,
        showNonCycleCertificate,
        nonCycleStudent,
        hasCertificateSupplement,
        locked,
        studentCertificate,
        studyProgramStudentSwitchedToId,
        droppedOut,
        hasGraduated
    }) {
        if (externalStudent) {
            if (!showMobilityCertificate) {
                return [DOC_TEXTS.TRANSCRIPT_OF_RECORDS, DOC_TEXTS.STATUS_CERTIFICATE];
            }
            return hasCertificateSupplement
                ? [DOC_TEXTS.TRANSCRIPT_OF_RECORDS, DOC_TEXTS.STATUS_CERTIFICATE, DOC_TEXTS.NON_CYCLE_CERTIFICATE, DOC_TEXTS.CERTIFICATE_SUPPLEMENT]
                : [DOC_TEXTS.TRANSCRIPT_OF_RECORDS, DOC_TEXTS.STATUS_CERTIFICATE, DOC_TEXTS.NON_CYCLE_CERTIFICATE];
        }

        if (nonCycleStudent) {
            if (!showNonCycleCertificate) {
                return [DOC_TEXTS.TRANSCRIPT_OF_RECORDS];
            }
            return hasCertificateSupplement
                ? [DOC_TEXTS.TRANSCRIPT_OF_RECORDS, DOC_TEXTS.NON_CYCLE_CERTIFICATE, DOC_TEXTS.CERTIFICATE_SUPPLEMENT]
                : [DOC_TEXTS.TRANSCRIPT_OF_RECORDS, DOC_TEXTS.NON_CYCLE_CERTIFICATE];
        }

        if ((locked && !studentCertificate) || studyProgramStudentSwitchedToId !== null || (!studentCertificate && droppedOut)) {
            return [DOC_TEXTS.TRANSCRIPT_OF_RECORDS, DOC_TEXTS.TRANSCRIPT_OF_RECORDS_PER_YEAR];
        }

        if (studentCertificate && droppedOut) {
            return [DOC_TEXTS.TRANSCRIPT_OF_RECORDS, DOC_TEXTS.TRANSCRIPT_OF_RECORDS_PER_YEAR, DOC_TEXTS.WITHDRAWAL];
        }

        if (studentCertificate && hasGraduated) {
            return [DOC_TEXTS.TRANSCRIPT_OF_RECORDS, DOC_TEXTS.TRANSCRIPT_OF_RECORDS_PER_YEAR, DOC_TEXTS.COMPLETED_STUDY_CYCLE_CERTIFICATE];
        }

        return [DOC_TEXTS.STATUS_CERTIFICATE, DOC_TEXTS.TRANSCRIPT_OF_RECORDS, DOC_TEXTS.TRANSCRIPT_OF_RECORDS_PER_YEAR];
    }

    render() {
        const {
            locked,
            studentCertificate,
            studyProgramStudentSwitchedToId,
            externalStudent,
            nonCycleStudent,
            droppedOut,
            graduationDate,
            student
        } = this.props;

        const {
            documentTypes,
            documentType,
            loading,
            certificateReason
        } = this.state;

        const localStatuses = JSON.parse(localStorage.getItem('studentStatuses') || '{}');
        const hasGraduated = graduationDate || localStatuses.graduationDate;

        const mobilityTypeKey = student && student.mobilityType && student.mobilityType._key;
        const hasCompletionData = !!student.graduationDate
            && !!(student.certificateNumber && String(student.certificateNumber).trim());

        const showMobilityCertificate = externalStudent
            && mobilityTypeKey === 'non_cycle'
            && hasCompletionData
            && !student.dropoutDate;

        const showNonCycleCertificate = nonCycleStudent && hasCompletionData && !student.dropoutDate;

        const hasCertificateSupplement = !!(student
            && student.nonCycleProgram
            && student.nonCycleProgram.hasCertificateSupplement);

        const allowedTexts = this.getAllowedDocumentTexts({
            externalStudent,
            showMobilityCertificate,
            showNonCycleCertificate,
            nonCycleStudent,
            hasCertificateSupplement,
            locked,
            studentCertificate,
            studyProgramStudentSwitchedToId,
            droppedOut,
            hasGraduated
        });

        const options = documentTypes.filter(el => allowedTexts.includes(el.text));

        const activeRole = localStorage.getItem('activeRole');
        const isDisabled =
            activeRole === 'Support' ||
            activeRole.substr(0, 19) === 'Prodekan za nastavu';

        const studentData = JSON.parse(localStorage.getItem('student'));
        const transcriptType = documentTypes.find(el => el.text === DOC_TEXTS.TRANSCRIPT_OF_RECORDS);
        const nonCycleCertificateType = documentTypes.find(el => el.text === DOC_TEXTS.NON_CYCLE_CERTIFICATE);
        const certificateSupplementType = documentTypes.find(el => el.text === DOC_TEXTS.CERTIFICATE_SUPPLEMENT);

        const actions = {
            4: () => this.graduationCerificate([studentData.id], studentData.studyCycleId),
            5: () => this.getWithdrawalForm(studentData.id),
            20: () => this.mobilityCerificate(student.id, this.state.language),
        };

        if (transcriptType) {
            actions[transcriptType.id] = () => {
                if (externalStudent && mobilityTypeKey === 'non_cycle') {
                    return this.nonCycleTranscript(student.id, this.state.language, 'external');
                }
                if (nonCycleStudent) {
                    return this.nonCycleTranscript(student.id, this.state.language, 'non-cycle');
                }
                return this.sendDocumentRequest(documentType, certificateReason);
            };
        }

        if (nonCycleCertificateType) {
            actions[nonCycleCertificateType.id] = () => {
                if (externalStudent) {
                    return this.mobilityCerificate(student.id, this.state.language);
                }
                if (nonCycleStudent) {
                    return this.nonCycleCerificate(student.id, this.state.language);
                }
                return this.sendDocumentRequest(documentType, certificateReason);
            };
        }

        if (certificateSupplementType) {
            actions[certificateSupplementType.id] = () => {
                if (externalStudent) {
                    return this.certificateSupplement(student.id, this.state.language, 'external');
                }
                if (nonCycleStudent) {
                    return this.certificateSupplement(student.id, this.state.language, 'non-cycle');
                }
                return this.sendDocumentRequest(documentType, certificateReason);
            };
        }

        const handleClick =
            actions[documentType] ||
            (() => this.sendDocumentRequest(documentType, certificateReason));

        return (
            <div>
                <Fragment>
                    <Segment.Group secondary>
                        <Segment clearing secondary>
                            <Form noValidate>
                                <Form.Group widths="equal">
                                    <Form.Field required>
                                        <label>  Tip potvrde</label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Izaberite tip potvrde"
                                            value={this.state.documentType}
                                            onChange={this.handleInputChange}
                                            name="documentType"
                                            options={options}
                                            search
                                            fluid
                                            selection
                                            error={this.state.documentTypeError}
                                        />
                                    </Form.Field>
                                    <Form.Field required>
                                        <label>  <FormattedMessage id="common.language" /></label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder={<FormattedMessage id="studentDocuments.selectLanguage" />}
                                            value={this.state.language}
                                            onChange={this.handleInputChange}
                                            name="language"
                                            options={this.state.documentLanguages}
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>
                                    {!this.props.externalStudent && !this.props.nonCycleStudent &&
                                        <Form.Field
                                            required
                                            disabled={this.state.documentType !== this.getStatusCertificateId()}
                                        >
                                            <label> Statusna potvrda</label>
                                            <Form.Dropdown
                                                clearable
                                                placeholder="Izaberite statusnu potvrdu"
                                                value={this.state.certificateReason}
                                                onChange={this.handleInputChange}
                                                name="certificateReason"
                                                options={this.state.certificateReasons}
                                                search
                                                fluid
                                                selection
                                                error={this.state.certificateReasonIdError}
                                            />
                                        </Form.Field>
                                    }
                                </Form.Group>
                                {this.props.studentCertificate === false ?
                                    <Button
                                        basic="true"
                                        color="blue"
                                        floated="right"
                                        onClick={this.props.closeGetRequestMode}
                                    >
                                        Odustani
                                    </Button> : null
                                }
                                <Button
                                    disabled={isDisabled}
                                    color="blue"
                                    floated="right"
                                    loading={loading}
                                    onClick={handleClick}
                                >
                                    Štampanje
                                </Button>
                            </Form>
                        </Segment>
                        <ToastContainer hideProgressBar />
                    </Segment.Group>
                </Fragment>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/CertificateRequest/GetCertificate.js